// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    h6: {
      fontSize: '0.85rem', // Ajustez la taille de la police pour h6
      fontWeight: 'bold',
    },
    body2: {
        fontSize: '0.75rem', 
        },
    subtitle1: {
          fontSize: '0.68rem',
          display: 'flex', 
          justifyContent:'flex-end',
          '& > span': { // Style pour un span enfant qui contiendra le texte
            display: 'inline-block',
            borderRadius: '8px',
            paddingLeft: '8px',
            paddingRight: '8px',
                           

        
            },
          
          

          },
  },

  palette: {
    primary: {
      main: '#01a3ab',
      light: '#01a3ab2e',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#f7183d',
      
    },

    grey: {
      main: '#acafb3',
      
    },
  },

});

export default theme;
